import { render, staticRenderFns } from "./NormalSearchNav590.vue?vue&type=template&id=12b4aff3&scoped=true&"
import script from "./NormalSearchNav590.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav590.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4aff3",
  null
  
)

export default component.exports